export const convertListToMap = <T>(list: string[], value: T) =>
  Object.fromEntries(list.map((item) => [item, value]))
